// extracted by mini-css-extract-plugin
export default {"appear-animation":"VJx3sr","appearAnimation":"VJx3sr","appear":"i8ia9V","floating-button":"O4zFjI","floatingButton":"O4zFjI"};